import { Router, ActivatedRoute } from '@angular/router';
import {Component, Input, OnInit, AfterViewInit, ViewChild, ComponentFactoryResolver, OnDestroy} from '@angular/core';
import {TogetherMainContentDirective} from './together.main.content.directive';
import {TogetherDIPComponent} from './components/dip.component';
import { TogetherHeaderLink, TogetherHeaderLinks, TogetherCurrentPage } from './models/app.models';

@Component({
    selector: 'together-page-content',
    templateUrl: './together.main.content.html',
    standalone: false
})
export class TogetherMainContentComponent implements AfterViewInit, OnInit {

  /**
   * Current routed URL.
   *
   * @type {string}
   * @memberof TogetherHeaderComponent
   */
  current_url: string;

  current_step: number;

  /**
   * The current page.
   */
  @Input() page: TogetherCurrentPage;

  @ViewChild(TogetherMainContentDirective) togetherPageComponentHost: TogetherMainContentDirective;
 
  selectPageComponent() {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(TogetherDIPComponent);
    let viewContainerRef = this.togetherPageComponentHost.viewContainerRef;
    viewContainerRef.clear();
    let componentRef = viewContainerRef.createComponent(componentFactory);
  }

  ngOnInit() { 

  }

  ngAfterViewInit() {
    //this.selectPageComponent();
  }

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private router: Router, private route: ActivatedRoute) {
  }

}
